// extracted by mini-css-extract-plugin
export default {"wrapper":"fileSharePanel_wrapper__FU-rO","selection":"fileSharePanel_selection__exMMx","list":"fileSharePanel_list__+0lHt"};